import React, { useMemo } from "react";
import { useDropzone } from "react-dropzone";
import { showToast } from "../components";
import { ACCEPTED_TYPES } from "../utils/constants";
interface DropZoneProps {
  onFilesDrop: (files: any) => Promise<void>;
  setLoading: (loading: boolean) => void;
}

const Dropzone = ({ onFilesDrop, setLoading }: DropZoneProps) => {
  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
  } = useDropzone({
    accept: ACCEPTED_TYPES,
    onDrop: (acceptedFiles, fileRejections) => {
      if (fileRejections.length > 0) {
        showToast("warning", "Type de fichier non accepter");
      } else {
        setTimeout(() => {
          onFilesDrop(acceptedFiles);
        }, 1000);
      }
    },
  });

  return (
    <section className="flex items-center justify-center ">
      <div
        {...getRootProps({ className: "dropzone" })}
        className={`border-4 p-4 border-dashed rounded-lg flex-rows space-y-2 px-60  
        ${isDragActive ? " border-blue-500 " : "bg-gray-100"}
        `}
        //         ${isDragAccept ? "border-green-500 bg-green-100" : ""}
        // ${isDragReject ? "bg-red-200 border-red-500" : ""}

        style={{ cursor: "pointer" }}
      >
        <input {...getInputProps()} />
        <div className="flex flex-col items-center  py-5">
          <img className=" w-10 h-10" src="images/box.png" />
          <strong className="text-center mt-2">Glisser déposer fichiers</strong>
        </div>
      </div>
    </section>
  );
};

export default Dropzone;
